import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-return-index",
  "use": "icon-return-index-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-return-index\">\n<path d=\"M94.174,109.776l48.918,48.918c5.401,5.401,5.401,14.159,0,19.56l0,0c-5.401,5.401-14.159,5.401-19.56,0l-68.478-68.478\n\tc-5.399-5.399-5.399-14.152,0-19.551l68.478-68.478c5.401-5.401,14.159-5.401,19.56,0l0,0c5.401,5.401,5.401,14.159,0,19.56\n\tL94.174,90.224C88.775,95.623,88.775,104.377,94.174,109.776z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/return-index.svg
// module id = mOLs
// module chunks = 3